// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"97c0f8d46ae24e60172c","642":"f52c6144ac6757537944","812":"de6802b8c53afdf96e6b","912":"2c541e963feac2e29a65"}[chunkId] + ".chunk.js";
};